import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { pipe, reduce } from 'ramda'
import styled from 'styled-components'
import { useMediaQuery } from '@mui/material'
import { breakpoints, colors } from '@/styles'
import { show as showManageRecipientsModal } from '@/pages/Contract/CustomContractCreate/add-signer/manage-recipients-modal'
import { displayExistingItems } from '@/pages/Contract/CustomContractCreate/utils'
import { showUpdateNotificationModal } from './update-notification-modal'
import Recipients from '../recipients.svg'
import RecipientsDesktop from '../recipients-icon.svg'

const RecipientsWrapper = styled.div`
  position: relative;
  cursor: pointer;
`
const Image = styled.img`
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  :hover {
    opacity: 0.5;
  }
`

const DropdownMenuItem = styled.span`
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: center;
  margin: 4px auto;
  padding: 10px 9px;
  border-radius: 8px;
  background-color: ${colors.white};
  cursor: pointer;
  color: ${props => props.color};

  &:hover,
  &:active {
    background-color: ${colors.grey96};
  }

  &:active {
    color: ${props => (props.color ? props.color : '#000000')};
  }
  &:disabled,
  &[disabled] {
    opacity: 0.3;
    cursor: not-allowed;
    user-select: none;
    pointer-events: none;
  }
  svg {
    margin-right: 10px;
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 16px;
    font-weight: 500;
    color: ${colors.black};
    margin: 0;
    padding: 16px;
    border-bottom: 1px solid #ddd;
    border-radius: 0;

    &:last-child {
      border-bottom: 0;
    }
  }
`

const RecipientsMenu = ({
  isNativeContract,
  viewContract,
  contract,
  packageFile,
  packageFiles = []
}) => {
  const dispatch = useDispatch()
  const node = useRef(null)
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)

  const formattedItems = pipe(
    reduce((acc, file) => {
      const existingItems = displayExistingItems(file?.fields_metadata?.pages)

      return {
        ...acc,
        [file?.id]: existingItems
      }
    }, {})
  )(packageFiles)

  const isContractSentOrSigned =
    packageFile?.state_machine === 'sent' || packageFile?.state_machine === 'signed'
  const handleClick = e => {
    e.stopPropagation()
    if (isNativeContract) {
      viewContract()
      return
    }
    if (isContractSentOrSigned) {
      showUpdateNotificationModal({ contract, packageFile, dispatch })
      return
    }
    showManageRecipientsModal({
      contractId: packageFile.listing_contract_id,
      currentDocument: packageFile?.id,
      items: formattedItems
    })
  }

  return (
    <RecipientsWrapper ref={node}>
      {isMobile ? (
        <DropdownMenuItem onClick={handleClick}>
          <Image src={Recipients} alt="more" />
          <span>Recipients</span>
        </DropdownMenuItem>
      ) : (
        <Image src={RecipientsDesktop} alt="more" onClick={handleClick} />
      )}
    </RecipientsWrapper>
  )
}

export default RecipientsMenu
